var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.$emit('click',$event)}}},[_vm._v(" HEADER ")])}
var staticRenderFns = []

export { render, staticRenderFns }